let multipleQuantityFieldsErrorContainer, multipleQuantityFieldsForm, multipleQuantityFieldsSubmitButtons, productForm, quantityFields, quantityFieldsContainer;

const getSelectedColor = function () {
  const colorSelector = document.querySelector('.option-selector[data-option*="Color"]');

  if (!colorSelector) {
    return 'default';
  }

  const activeColor = colorSelector.querySelector('input[type="radio"]:checked');

  if (activeColor) {
    return activeColor.value;
  }

  return 'default';
};

const updateVisibleQuantityFields = function() {
  if (!quantityFieldsContainer) return;

  const selectedColor = getSelectedColor();
  const quantityFields = quantityFieldsContainer.querySelectorAll('.js-quantity-field');

  quantityFields.forEach(function(field) {
    const fieldColor = field.getAttribute('data-color');

    if (!fieldColor || fieldColor === selectedColor) {
      field.style.display = '';

      return;
    }

    field.style.display = 'none';
  });
};

const updateOneSizeVariantId = function() {
  const colorVariantMapElement = document.getElementById('color-variant-map');
  const oneSizeInput = document.getElementById('quantity-field-one-size');

  if (!colorVariantMapElement || !oneSizeInput) return;

  const selectedColor = getSelectedColor();

  if (selectedColor === 'default') return;

  try {
    const colorVariantMap = JSON.parse(colorVariantMapElement.textContent);

    if (colorVariantMap[selectedColor]) {
      oneSizeInput.setAttribute('data-variant-id', colorVariantMap[selectedColor]);
    }
  } catch (e) {
    console.error('Error parsing color-variant-map:', e);
  }
};

const resetQuantityFields = async function () {
  const isSingleField = quantityFields && quantityFields.length === 1;

  Array.from(quantityFields).forEach(function (field) {
    if (isSingleField) {
      field.value = '1';

      return;
    }

    field.value = '';
  });
};

const disableButtons = async function () {
  multipleQuantityFieldsSubmitButtons.forEach(button => {
    button.setAttribute('disabled', 'disabled');
    button.textContent = 'Adding...';
  });
};

const enableButtons = async function () {
  multipleQuantityFieldsSubmitButtons.forEach(button => {
    button.removeAttribute('disabled');
    button.textContent = button.getAttribute('data-add-to-cart-text');
  });
};

const getSelectedCombinations = async function () {
  const selectedCombinations = [];

  Array.from(quantityFields).forEach(function (field) {
    const quantity = parseInt(field.value, 10);
    const variantId = field.getAttribute('data-variant-id');

    if (!isNaN(quantity) && quantity > 0) {
      selectedCombinations.push({
        id: variantId,
        quantity: quantity,
      });
    }
  });

  return selectedCombinations;
};

const removeError = async function () {
  multipleQuantityFieldsErrorContainer.innerHTML = '';
};

const showError = async function () {
  if (multipleQuantityFieldsErrorContainer.querySelector('p')) {
    return;
  }

  multipleQuantityFieldsErrorContainer.insertAdjacentHTML('beforeend', '<p>We’re sorry, but an error has occurred. Please try again later.</p>');
};

const handleSubmit = async function (event) {
  let selectedCombinations = await getSelectedCombinations();

  const method = multipleQuantityFieldsForm.getAttribute('method');
  const url = multipleQuantityFieldsForm.getAttribute('action');
  const productId = parseInt(productForm.querySelector('input[name="product-id"]').value, 10);
  const sectionId = productForm.querySelector('input[name="section-id"]').value;
  const sectionsToUpdate = ['page-header', 'cart-drawer'].map((sel) => document.querySelector(sel)).filter((el) => el); // main.js:2702
  const sectionIds = sectionsToUpdate.map((el) => el.dataset.sectionId); // main.js:2703

  const handleAjax = async function () {
    selectedCombinations = selectedCombinations.map(combination => {
      return { ...combination, properties: {} };
    });

    // Add additional properties from Infinite Options to the array
    selectedCombinations = selectedCombinations.map((combination) => {
      const selectedInputs = Array.from(document.getElementById('infiniteoptions-container').querySelectorAll('input[type="radio"]:checked, input[type="checkbox"]:checked'));

      selectedInputs.forEach((input) => {
        let inputName, inputValue;

        if (input.type === 'radio') {
          inputName = input.getAttribute('name');
          inputValue = input.value;
        } else {
          inputName = input.closest('fieldset').querySelector('input[type="hidden"]').getAttribute('name');
          inputValue = input.value;
        }

        if (inputName === 'properties[Decoration Location]' && inputValue === 'Other') {
          const otherField = document.getElementById('other-field');

          if (otherField) {
            inputValue = otherField.value;
          }
        }

        if (inputName === 'properties[Extras]' && inputValue === 'Names/Titles') {
          const namesTitlesField = document.getElementById('names-titles-field');

          if (namesTitlesField) {
            inputValue = 'Names/Titles: ' + namesTitlesField.value;
          }
        }

        if (!inputName || !inputValue) return;

        inputName = inputName.replace('properties[', '').replace(']', '');

        if (combination.properties[inputName]) {
          combination.properties[inputName] += `, ${inputValue}`;
        } else {
          combination.properties[inputName] = inputValue;
        }
      });

      return combination;
    });

    selectedCombinations = selectedCombinations.map((combination) => {
      const thisFormData = new FormData(document.querySelector('.js-product-form'));
      const uploadedLogo = thisFormData.get('properties[pdp upload]');
      const uploadedLogo2 = thisFormData.get('properties[pdp upload 2]');
      const uploadedLogo3 = thisFormData.get('properties[pdp upload 3]');

      if (uploadedLogo) {
        combination.properties['Logo'] = uploadedLogo;
      }
      if (uploadedLogo2) {
        combination.properties['Logo 2'] = uploadedLogo2;
      }
      if (uploadedLogo3) {
        combination.properties['Logo 3'] = uploadedLogo3;
      }

      return combination;
    });

    let formData = {
      'items': selectedCombinations,
      'product-id': productId,
      'sections': sectionIds.join(','),
      'section-id': sectionId,
      'sections_url': window.location.pathname
    }

    let productTitle = '';

    async function addToCart() {
      try {
        const response = await fetch(url, {
          method: method,
          headers: {
            Accept: 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });

        if (!response.ok) {
          // If the response is not OK, throw an error with the status text
          const errorData = await response.json();
          throw new Error(`Error ${response.status}: ${errorData.message || 'Unknown error'}`);
        }

        const data = await response.json();

        if (data.items && data.items.length > 0) {
          if (data.items[0] && data.items[0]['product_title']) {
            productTitle = data.items[0]['product_title'];
          }
        }

        // main.js:2739
        if (data.sections && sectionsToUpdate.length === Object.keys(data.sections).length) {
          sectionsToUpdate.forEach((el) => {
            el.updateFromCartChange(data.sections[el.dataset.sectionId]);
          });
        } else {
          // Unexpected null section return has been observed
          this.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        }

        this.dispatchEvent(new CustomEvent('on:cart:add', {
          bubbles: true,
          detail: {
            variantId: data.variant_id
          }
        }));
      } catch (error) {
        throw new Error(error);
      }
    }

    await removeError();
    await disableButtons();

    try {
      await addToCart();
    } catch (error) {
      console.error('Error2:', error);
      showError();
      enableButtons();
      return; // stops further execution
    }

    // isFinished
    await enableButtons();
    await resetQuantityFields();
    if (theme.settings.afterAddToCart === 'notification') {
      const notification = document.getElementById('AddedNotification').content.firstElementChild.cloneNode(true);
      notification.dataset.productTitle = productTitle;
      let notificationContainer = document.querySelector('.pageheader--sticky');
      if (!notificationContainer) {
        notificationContainer = document.querySelector('body');
      }
      notificationContainer.appendChild(notification);
    } else if (theme.settings.afterAddToCart === 'drawer') {
      if (document.querySelector('.js-cart-drawer')) {
        document.querySelector('.js-cart-drawer').open();
      }
    } else {
      window.location.href = theme.routes.cart;
    }
  }

  const showError = function (errorText) {
    multipleQuantityFieldsErrorContainer.innerHTML = '';
    multipleQuantityFieldsErrorContainer.insertAdjacentHTML('beforeend', `<p>${errorText}</p>`);
    document.getElementById('multiple-quantity-fields-form').scrollIntoView({ behavior: 'smooth' });
  }

  event.preventDefault();

  if (selectedCombinations.length === 0) {
    showError('Please ensure that you have selected sizes for your order.');

    return;
  }

  if (document.querySelector('.js-product-info-accordion--order-customization')) {
    const decorationTypeField = document.querySelector('input[name="properties[Decoration Type]"]:checked');
    const decorationLocationField = document.querySelector('input[name="properties[Decoration Location]"]')?.value;
    const logoField = document.querySelector('input[name="properties[Logo]"]:checked');

    if (!decorationTypeField || !decorationLocationField || !logoField) {
      showError('Please ensure that you have filled out all options, including those under the "Customize Your Order" section.');
      document.querySelector('.js-product-info-accordion--order-customization .disclosure').open = true;

      return;
    }
  }

  await handleAjax()
};

const initializeQuantityFields = function() {
  multipleQuantityFieldsErrorContainer = document.getElementById('multiple-quantity-fields-error-container');
  multipleQuantityFieldsForm = document.getElementById('multiple-quantity-fields-form');
  multipleQuantityFieldsSubmitButtons = [document.getElementById('additional-buy-button')];
  productForm = document.querySelector('.js-product-form');
  quantityFieldsContainer = document.getElementById('quantity-fields-container');

  if (!multipleQuantityFieldsForm || !quantityFieldsContainer || !productForm) {
    return;
  }

  quantityFields = quantityFieldsContainer.querySelectorAll('.js-quantity-field__input');

  updateVisibleQuantityFields();
  updateOneSizeVariantId();

  const colorSelector = document.querySelector('.option-selector[data-option*="Color"]');

  if (colorSelector) {
    const radioInputs = colorSelector.querySelectorAll('input[type="radio"]');

    radioInputs.forEach(function(radio) {
      radio.addEventListener('change', function() {
        updateVisibleQuantityFields();
        updateOneSizeVariantId();
      });
    });
  }

  if (multipleQuantityFieldsForm) {
    multipleQuantityFieldsForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      await handleSubmit(e);
    });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeQuantityFields);
} else {
  initializeQuantityFields();
}

if (document.getElementById('additional-buy-button') && document.getElementById('multiple-quantity-fields-submit-button')) {
  document.getElementById('additional-buy-button').addEventListener('click', function (event) {
    document.getElementById('multiple-quantity-fields-submit-button').click();
  });
}

// Additional fields
const headingObserver = new MutationObserver(function () {
  const headingElementWrapper = document.createElement('div');
  headingElementWrapper.className = 'infinite-options-heading-wrapper js-infinite-options-heading-wrapper';

  const headingElement = document.createElement('p');
  headingElement.className = 'infinite-options-heading js-infinite-options-heading';
  headingElement.textContent = 'Customize Your Order';

  const headingSubtitle = document.createElement('p');
  headingSubtitle.className = 'infinite-options-heading-subtitle';
  headingSubtitle.innerHTML = '<strong>Online price includes 1 Logo, Embroidered or Printed, in 1 location.</strong>';

  document.getElementById('infiniteoptions-container').insertAdjacentElement('afterbegin', headingElementWrapper);
  document.querySelector('.js-infinite-options-heading-wrapper').insertAdjacentElement('afterbegin', headingElement);
  headingElementWrapper.insertAdjacentElement('afterend', headingSubtitle);

  headingObserver.disconnect();
});

const supplementalTextObserver = new MutationObserver(function () {
  const supplementalTextConfiguration = [
    {
      element: document.querySelector('input[type="checkbox"][value="Left Chest"]'),
      text: '(Standard logo placement)',
    },
    {
      element: document.querySelector('input[type="checkbox"][value="Full Back Print"]'),
      text: '($30 USD setup fee + $9 USD/shirt if this is a second logo location)',
    },
    {
      element: document.querySelector('input[type="checkbox"][value="Full Chest Print"]'),
      text: '($30 USD setup fee + $9 USD/shirt if this is a second logo location)',
    },
    {
      element: document.querySelector('input[type="checkbox"][value="Add a Second Embroidered Logo"]'),
      text: '($30 USD setup fee + $6 USD/item)',
    },
    {
      element: document.querySelector('input[type="checkbox"][value="Add a Third Embroidered Logo"]'),
      text: '($30 USD setup fee + $6 USD/item)',
    },
    {
      element: document.querySelector('input[type="checkbox"][value="Names/Titles"]'),
      text: '($7 USD/item)',
    },
    {
      element: document.querySelector('input[type="checkbox"][value="Second Side Printed Logo"]'),
      text: '($30 USD setup fee + $9 USD/shirt)',
    },
  ];

  supplementalTextConfiguration.forEach((config) => {
    if (!config.element) return;

    const appendText = function (text, className) {
      if (!text) return;

      const supplementalText = document.createElement('span');
      supplementalText.className = className;
      supplementalText.innerText = text;

      config.element.parentElement.insertAdjacentElement('beforeend', supplementalText);
    };

    // "emphasisText" goes last so the plain pricing note reads first and the
    // charge we want to stand out follows it in red.
    appendText(config.text, 'supplemental-text');
    appendText(config.emphasisText, 'supplemental-text supplemental-text--emphasis');
  });

  supplementalTextObserver.disconnect();
});

const helpTextObserver = new MutationObserver(function () {
  const svgIcon = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>';
  const helpTextConfiguration = [
    {
      element: document.querySelector('.js-infinite-options-heading'),
      text: '<p>Please specify your logo placement and decoration preferences. An artwork proof will be emailed for review within 24-48 hours of order submission. Any applicable upcharges for logo size or additional locations will be billed separately.</p>',
    },
    {
      element: document.querySelector('input[type="radio"][value="Embroidered"]'),
      text: '<p>Standard decoration is an embroidered (sewn) left chest logo.</p>',
    },
    {
      element: document.querySelector('input[type="radio"][value="Print"]'),
      text: '<p>Printing services are available; rates vary based on number of print locations, color count, and logo size.</p>',
    },
    {
      element: document.querySelector('input[type="radio"][value="Sample"]'),
      text: '<p>You can order this item as a blank sample (with no logo) to review and return within 20 days for restock and refund.</p>',
    },
    {
      element: document.querySelector('label[id="Decoration Location-1-0"]'),
      text: '<p>Standard location is left chest, but you can select a different location. See Chart - <img src="//logoshirtsdirect.com/cdn/shop/t/81/assets/shirt-placement.png?v=126537306157416355171789563734" alt="" /></p>',
    },
    {
      element: document.querySelector('input[type="radio"][value="Logo on File"]'),
      text: '<p>If you already have your logo on file, you do not need to upload it again. Our Art Team will still email a confirmation of the logo for your review.</p>',
    },
    {
      element: document.querySelector('input[type="radio"][value="Add Logo Later"]'),
      text: '<p>If you do not already have your logo ready, you can email <a href="mailto:art@logoshirtsdirect.com">Art@LogoShirtsDirect.com</a> when it is ready or to request help such as creating a text only logo.</p>',
    },
    {
      element: document.querySelector('input[type="checkbox"][value="Add a Second Embroidered Logo"]'),
      text: `
        <p>You can add a second logo to another location on your shirt. You will need to pay a one-time setup fee to create this logo and a per item embroidery charge of $6 per item.</p>
        <p><strong>These charges will be added separately from the online cart.</strong></p>
      `,
    },
    {
      element: document.querySelector('input[type="checkbox"][value="Add a Third Embroidered Logo"]'),
      text: `
        <p>You can add a third logo to another location on your shirt. You will need to pay a one-time setup fee to create this logo and a per item embroidery charge of $6 per item.</p>
        <p><strong>These charges will be added separately from the online cart.</strong></p>
      `,
    },
    {
      element: document.querySelector('input[type="checkbox"][value="Names/Titles"]'),
      text: `
        <p>You can add Name/Titles to the opposite side of your shirt for an additional $7 per item that gets Names/Titles.</p>
        <p><strong>These charges will be added separately from the online cart.</strong></p>
      `,
    },
  ];

  helpTextConfiguration.forEach((config) => {
    if (!config.element) return;

    const helpTooltip = document.createElement('div');
    helpTooltip.className = 'product-option-help-tooltip js-product-option-help-tooltip';

    const helpIcon = document.createElement('button');
    helpIcon.className = 'product-option-help-icon js-product-option-help-icon';
    helpIcon.type = 'button';

    const helpText = document.createElement('div');
    helpText.className = 'product-option-help-text js-product-option-help-text';

    helpIcon.innerHTML = svgIcon;
    helpText.innerHTML = config.text;

    config.element.parentElement.insertAdjacentElement('beforeend', helpTooltip);
    config.element.parentElement.querySelector('.js-product-option-help-tooltip').insertAdjacentElement('beforeend', helpIcon);
    config.element.parentElement.querySelector('.js-product-option-help-tooltip').insertAdjacentElement('beforeend', helpText);
    config.element.parentElement.classList.add('has-tooltip');
  });

  Array.from(document.querySelectorAll('.js-product-option-help-tooltip')).forEach(function (container) {
    const button = container.querySelector('.js-product-option-help-icon');
    const tooltip = container.querySelector('.js-product-option-help-text');

    const updateTooltip = function () {
      window.FloatingUIDOM.computePosition(button, tooltip, {
        placement: 'bottom',
        middleware: [
          window.FloatingUIDOM.flip(),
          // window.FloatingUIDOM.offset(5),
          window.FloatingUIDOM.shift(),
        ],
      }).then(({ x, y }) => {
        Object.assign(tooltip.style, {
          left: `${x}px`,
          top: `${y}px`,
        });
      });
    };

    const showTooltip = function () {
      tooltip.style.display = 'block';
      updateTooltip();
    };

    const hideTooltip = function () {
      tooltip.style.display = 'none';
    }

    container.addEventListener('mouseenter', showTooltip);
    container.addEventListener('mouseleave', hideTooltip);

    button.addEventListener('click', showTooltip);
    document.addEventListener('click', function (event) {
      if (!container.contains(event.target) && !button.contains(event.target)) {
        hideTooltip();
      }
    });
  });

  helpTextObserver.disconnect();
});

const otherFieldObserver = new MutationObserver(function () {
  const otherRadioButton = document.querySelector('input[type="checkbox"][value="Other"]');

  if (!otherRadioButton) return;

  const otherFieldElement = document.createElement('input');
  otherFieldElement.className = 'other-field';
  otherFieldElement.id = 'other-field';
  otherFieldElement.type = 'text';

  otherRadioButton.parentElement.insertAdjacentElement('beforeend', otherFieldElement);

  otherFieldObserver.disconnect();
});

const namesTitlesFieldObserver = new MutationObserver(function () {
  const namesTitlesRadioButton = document.querySelector('input[type="checkbox"][value="Names/Titles"]');

  if (!namesTitlesRadioButton) return;

  const namesTitlesFieldElement = document.createElement('input');
  namesTitlesFieldElement.className = 'names-titles-field';
  namesTitlesFieldElement.id = 'names-titles-field';
  namesTitlesFieldElement.type = 'text';

  namesTitlesRadioButton.parentElement.insertAdjacentElement('beforeend', namesTitlesFieldElement);

  namesTitlesFieldObserver.disconnect();
});

const uploadButtonObserver = new MutationObserver(function () {
  const uploadRadioButton = document.querySelector('input[type="radio"][value="Upload your logo"]');

  if (!uploadRadioButton) return;

  const uploadButtonElement = document.getElementById('photouploadapp');
  if (uploadButtonElement) {
    uploadButtonElement.parentElement.removeChild(uploadButtonElement);
    uploadRadioButton.parentElement.insertAdjacentElement('beforeend', uploadButtonElement);
    uploadButtonElement.style.display = 'block';
  } else {
    const contentObserver = new MutationObserver(function (mutations, observer) {
      const uploadButtonElement = document.getElementById('photouploadapp');

      if (uploadButtonElement) {
        observer.disconnect();

        uploadButtonElement.parentElement.removeChild(uploadButtonElement);
        uploadRadioButton.parentElement.insertAdjacentElement('beforeend', uploadButtonElement);
        uploadButtonElement.style.display = 'block';
      }
    });

    const content = document.getElementById('content');

    if (content) {
      contentObserver.observe(content, { childList: true, subtree: true });
    }
  }

  document.getElementById('upload-logo-anchor').addEventListener('click', function () {
    document.querySelector('.js-product-info-accordion--order-customization .disclosure').open = true;
    document.querySelector('.js-product-info-accordion--order-customization').scrollIntoView({ behavior: 'smooth' });
  });

  uploadButtonObserver.disconnect();
});

const defaultDecorationLocationObserver = new MutationObserver(function () {
  const fieldsets = document.querySelectorAll('#infiniteoptions-container fieldset');

  fieldsets.forEach(fieldset => {
    const legend = fieldset.querySelector('legend');

    if (legend && legend.textContent.trim() === 'Choose decoration location') {
      const checkbox = fieldset.querySelector('input[type="checkbox"]');

      if (checkbox) {
        checkbox.checked = true;
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  defaultDecorationLocationObserver.disconnect();
});

if (document.getElementById('additional-fields')) {
  document.getElementById('additional-fields').appendChild(document.getElementById('infiniteoptions-container'));
  document.getElementById('additional-fields').closest('.product-info-accordion').classList.add('product-info-accordion--order-customization', 'js-product-info-accordion--order-customization');
}

headingObserver.observe(document.getElementById('infiniteoptions-container'), { childList: true });
supplementalTextObserver.observe(document.getElementById('infiniteoptions-container'), { childList: true });
helpTextObserver.observe(document.getElementById('infiniteoptions-container'), { childList: true });
otherFieldObserver.observe(document.getElementById('infiniteoptions-container'), { childList: true });
namesTitlesFieldObserver.observe(document.getElementById('infiniteoptions-container'), { childList: true });
uploadButtonObserver.observe(document.getElementById('infiniteoptions-container'), { childList: true });
defaultDecorationLocationObserver.observe(document.getElementById('infiniteoptions-container'), { childList: true });

// Hide 2nd/3rd upload fields by default, show when their checkbox is checked.
// This uses a separate observer on the document body because both the Infinite Options
// checkboxes and the Uploadly upload fields need to exist before we can wire up the toggle.
const uploadFieldVisibilityObserver = new MutationObserver(function () {
  const additionalUploadFields = [
    { fieldname: 'pdp upload 2', checkbox: 'Add a Second Embroidered Logo' },
    { fieldname: 'pdp upload 3', checkbox: 'Add a Third Embroidered Logo' },
  ];

  const allReady = additionalUploadFields.every(function (config) {
    return document.querySelector('input[type="checkbox"][value="' + config.checkbox + '"]')
      && document.querySelector('[data-ph-fieldname="' + config.fieldname + '"]');
  });

  if (!allReady) return;

  additionalUploadFields.forEach(function (config) {
    const checkbox = document.querySelector('input[type="checkbox"][value="' + config.checkbox + '"]');
    const field = document.querySelector('[data-ph-fieldname="' + config.fieldname + '"]');

    if (!field) return;

    const updateVisibility = function () {
      field.style.display = checkbox.checked ? 'block' : 'none';
    };

    updateVisibility();
    checkbox.addEventListener('change', updateVisibility);
  });

  uploadFieldVisibilityObserver.disconnect();
});

uploadFieldVisibilityObserver.observe(document.body, { childList: true, subtree: true });
